<template>
  <div class="templates-main-menu d-flex align-items-center">
    <router-link
      :to="{ name: 'home' }"
      class="btn"
      @click="$emit('click-menu')"
    >
      <span>Início</span>
    </router-link>
    <router-link
      :to="{ name: 'courses' }"
      class="btn"
      @click="$emit('click-menu')"
    >
      <span>Cursos</span>
    </router-link>
    <router-link
      :to="{ name: 'library' }"
      class="btn"
      @click="$emit('click-menu')"
    >
      <span>Livros</span>
    </router-link>
    <router-link
      :to="{ name: 'conferences' }"
      class="btn"
      @click="$emit('click-menu')"
    >
      <span>Conferências</span>
    </router-link>
    <router-link
      :to="{ name: 'masters' }"
      class="btn"
      @click="$emit('click-menu')"
    >
      <span>Mestres</span>
    </router-link>
    <router-link
      :to="{ name: 'kids' }"
      class="btn"
      @click="$emit('click-menu')"
    >
      <span>Fiel Kids</span>
    </router-link>
    <router-link
      :to="{ name: 'podcasts' }"
      class="btn"
      @click="$emit('click-menu')"
    >
      <span>Podcasts</span>
    </router-link>
    <router-link
      :to="{ name: 'articles' }"
      class="btn"
      @click="$emit('click-menu')"
    >
      <span>Artigos</span>
    </router-link>
    <router-link
      :to="{ name: 'my-list' }"
      class="btn"
      @click="$emit('click-menu')"
    >
      <span>Minha Lista</span>
    </router-link>

    <div class="flex-fill" />

    <search-all class="hide-footer me-2 d-lg-block d-none" />

    <notification-drop-down additional-classes="d-none d-lg-block" />

    <profile-menu-drop-down
      additional-classes="d-lg-inline-flex d-none"
      @click-menu="$emit('click-menu')"
      @logout="$emit('logout')"
    />
  </div>
</template>

<script>
  import NotificationDropDown from "@/components/notifications/NotificationDropDown.vue";
  import ProfileMenuDropDown from "@/components/ProfileMenuDropDown.vue";
  import SearchAll from "./SearchAll";

  export default {
    components: { SearchAll, NotificationDropDown, ProfileMenuDropDown },
    methods: {
      clickDropdown() {
        this.$emit("click-menu");
        this.$refs.dropdown.hide(true);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .btn-logout {
    color: hsla(0, 100%, 64%, 1) !important;
  }

  :deep(.router-link-exact-active) {
    &,
    & > * {
      font-weight: 700;
      color: #63c98f !important;
    }
  }
  .templates-main-menu {
    .btn {
      font-weight: 400;
      color: #fff;

      @media screen and (min-width: 991px) and (max-width: 1050px) {
        span {
          font-size: 14px;
        }
      }

      @media screen and (min-width: 1051px) and (max-width: 1199px) {
        span {
          font-size: 15px;
        }
      }
    }

    .user-picture {
      height: 32px;
      width: 32px;
      border-radius: 50%;
    }

    .user-name-letter {
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      color: #181717;
      height: 32px;
      width: 32px;
      background: #ffffff;
      border-radius: 50%;

      display: flex;
      align-items: center;
      justify-content: center;
    }

    :deep(.btn) {
      display: flex;
      align-items: center;
      font-weight: 400;
    }

    :deep(.dropdown-item) {
      text-transform: uppercase !important;
      color: #fff !important;
      font-size: 12px;
      padding-top: 6px;
      padding-bottom: 6px;
      font-weight: 400;
    }
  }

  .wrapper-dropdown {
    background: #0b0b0b;
    border: 1px solid transparent;

    padding: 1rem 0 !important;
    margin-top: 5px;

    // height: 80vh;
    max-height: 540px;

    & :deep(>) * {
      padding-left: 1.5rem !important;
      padding-right: 1.5rem !important;
    }

    hr {
      background: white;
      height: 2px;
    }

    :deep(.el-dropdown__popper) {
      background: red;
    }

    :deep(.el-dropdown-menu__item) {
      a {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-weight: 400;
      }

      &,
      & * {
        color: #fff;
      }

      &:hover {
        background-color: #333333 !important;
      }

      i {
        font-size: 20px;
        color: black;
        margin-right: 1rem;
      }
    }
  }
</style>
